<template>
  <v-card>
    <card-title-bar icon="mdi-history" text="注文履歴"></card-title-bar>

    <v-card-text class="pa-0">
      <v-expansion-panels accordion>

        <!-- 履歴 -->
        <v-expansion-panel v-for="history in histories" :key="history.id">
          <v-expansion-panel-header class="px-3">
            {{ history.order_date }} : {{ history.status_name }}
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pa-0 grey--text">
            <template v-for="item in history.details">
              <div class="text-caption" :key="`row1-${item.id}`">
                {{ item.merchandise_name }} - {{ item.merchandise_type_name }}
              </div>
              <div class="text-caption text-end" :key="`row2-${item.id}`">
                <span class="mr-3">数量:{{item.qty}}</span>    
                <span>{{ item.amount | toPriceFormat }}</span>
              </div>
              <v-divider
                :key="`divider-${item.id}`"
              ></v-divider>
            </template>
            <div class="text-end">
              送料: {{ history.aggregate.postage_subtotal | toPriceFormat }}
            </div>
            <div class="text-end">
              合計: {{ history.aggregate.total_amount | toPriceFormat }}
            </div>
            <v-btn 
              v-if="history.status_id==statusOrder"
              @click.stop="orderCancel(history)"
            >
              注文を取り消す
            </v-btn>
            <v-btn 
              v-if="history.status_id==statusComplete" 
              color="primary"
              @click.stop="orderAgain(history.details)"
            >
              この内容で再注文する
            </v-btn>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- 履歴読み込み中 -->
        <v-expansion-panel v-if="!this.histories">
          <v-expansion-panel-header class="grey--text text-caption">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="px-4 grey--text">
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- 履歴0件 -->
        <v-expansion-panel v-else-if="this.histories.length == 0">
          <v-expansion-panel-header class="grey--text text-caption">
            今年度の履歴はありません
          </v-expansion-panel-header>
          <v-expansion-panel-content class="px-4 grey--text">
          </v-expansion-panel-content>
        </v-expansion-panel>

      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script>
import CardTitleBar from './parts/CardTitleBar'

export default {
  name: 'OrderHistory', 
  components: {
    CardTitleBar,
  },
  props:{
    histories: Array,
    statusOrder: Number,
    statusComplete: Number,
  },
  methods: {
    orderAgain(details) {
      this.$emit('order-again-click', details)
    },
    orderCancel(history) {
      this.$emit('order-cancel-click', history)
    }
  },
}
</script>